module.exports = __webpack_public_path__ + "static/img/商品详情@3x.eb0715e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/首页/商品详情@3x.png
// module id = 5x5O
// module chunks = 192